

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETUSERPROFILEBANNER= createAsyncThunk(
  "getUserProfileBanner/getUserProfileBanner",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getUserProfileBannerSlice = createSlice({
  name: "getUserProfileBannerSlice",
  initialState: {
    getUserProfileBanner: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetUserProfileBanner: (state) => {
        state.getUserProfileBanner.loading = false
        state.getUserProfileBanner.error = false
        state.getUserProfileBanner.data = []
        state.getUserProfileBanner.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETUSERPROFILEBANNER.fulfilled, (state, action) => {
      state.getUserProfileBanner = {
        ...state.getUserProfileBanner,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERPROFILEBANNER.pending, (state, action) => {
      state.getUserProfileBanner = {
        ...state.getUserProfileBanner,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETUSERPROFILEBANNER.rejected, (state, action) => {
      state.getUserProfileBanner = {
        ...state.getUserProfileBanner,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getUserProfileBannerAction = {
    GETUSERPROFILEBANNER,
};

export { getUserProfileBannerAction };
export default getUserProfileBannerSlice.reducer;
export const {setInitialStateOfgetUserProfileBanner} = getUserProfileBannerSlice.actions